import axios from 'axios';
import { API_BASE_URL } from '../config/api.config';

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 segundos - aumentado para consultas grandes
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token JWT automáticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado o inválido
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_proveedor');
      window.location.reload(); // Forzar recarga para mostrar login
    }
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Servicios específicos
export const authService = {
  login: (username: string, password: string) =>
    api.post('/auth/login', { username, password }),

  register: (data: any) =>
    api.post('/auth/registro', data),

  getPerfil: () =>
    api.get('/auth/perfil'),
};

export const rutasService = {
  getDisponibles: () =>
    api.get('/rutas/disponibles'),

  getTablaCompleta: (params?: {
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: string;
    origen_ciudad?: string;
    destino_ciudad?: string;
    tipo_vehiculo?: string;
    tipo_carga?: string;
    configuracion?: string;
  }) =>
    api.get('/rutas/tabla-real', { params }), // Usando datos reales de SICETAC_TARIFAS

  getEstadisticas: () =>
    api.get('/rutas/estadisticas'),

  actualizar: (data: {
    origen_ciudad: string;
    destino_ciudad: string;
    tipo_vehiculo: string;
    tipo_carga: string;
    configuracion: string;
    valor_de_tarifa?: number;
    comentarios?: string;
  }) =>
    api.put('/rutas/actualizar', data),

  guardarPropuestaProveedor: (data: {
    proveedor: string;
    origen_ciudad: string;
    destino_ciudad: string;
    tipo_vehiculo: string;
    tipo_carga: string;
    configuracion: string;
    valor_sicetac: number;
    valor_de_tarifa: number;
    comentarios: string;
  }) =>
    api.post('/rutas/guardar-propuesta-proveedor', data),

  filtrar: (filtros: any) =>
    api.post('/rutas/filtrar', filtros),

  getDetalle: (rutaId: number) =>
    api.get(`/rutas/${rutaId}`),

  crearPropuesta: (data: any) =>
    api.post('/licitaciones/propuesta', data),

  getMisPropuestas: () =>
    api.get('/licitaciones/mis-propuestas'),
};

// Servicio para Rutas Granel (SICETAC_TARIFAS_GRANEL)
export const rutasGranelService = {
  getTablaCompleta: (params?: {
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: string;
    origen_ciudad?: string;
    destino_ciudad?: string;
    tipo_vehiculo?: string;
    tipo_carga?: string;
    configuracion?: string;
    proveedor?: string;  // Agregado para obtener propuestas del proveedor
  }) =>
    api.get('/rutas-granel/tabla-real', { params }),

  getEstadisticas: () =>
    api.get('/rutas-granel/estadisticas'),

  actualizar: (data: {
    origen_ciudad: string;
    destino_ciudad: string;
    tipo_vehiculo: string;
    tipo_carga: string;
    configuracion: string;
    valor_de_tarifa?: number;
    comentarios?: string;
  }) =>
    api.put('/rutas-granel/actualizar', data),

  guardarPropuestaProveedor: (data: {
    proveedor: string;
    origen_ciudad: string;
    destino_ciudad: string;
    tipo_vehiculo: string;
    tipo_carga: string;
    configuracion: string;
    valor_sicetac: number;
    valor_de_tarifa: number;
    comentarios: string;
  }) =>
    api.post('/rutas-granel/guardar-propuesta-proveedor', data),
};

export const bodegasService = {
  getDisponibles: () =>
    api.get('/bodegas/disponibles'),

  crearPropuesta: (data: any) =>
    api.post('/bodegas/propuesta', data),

  getMisPropuestas: () =>
    api.get('/bodegas/mis-propuestas'),
};

export const carbonService = {
  registrar: (data: any) =>
    api.post('/huella-carbono/registro', data),

  consultar: () =>
    api.get('/huella-carbono/consulta'),
};

export const proveedorService = {
  getPerfil: () =>
    api.get('/proveedor/perfil'),

  getEstadisticas: () =>
    api.get('/proveedor/estadisticas'),
};

export const healthService = {
  check: () =>
    api.get('/health'),

  validateMySQL: () =>
    api.get('/validate-mysql'),
};

export default api;
